import { createClient } from "@supabase/supabase-js";

// Single configuration for all business types
export const SUPABASE_CONFIG = {
  URL: "https://mbppphoddpitkedffmao.supabase.co", // Use your main database
  ANON_KEY: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1icHBwaG9kZHBpdGtlZGZmbWFvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzA5MDk1MTQsImV4cCI6MjA0NjQ4NTUxNH0.8e1ugDoUBryeoMGKgV0AVRuYnNq1AKSplXUL-qCys5Q",
  SERVICE_KEY: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1icHBwaG9kZHBpdGtlZGZmbWFvIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTczMDkwOTUxNCwiZXhwIjoyMDQ2NDg1NTE0fQ._UezhGRf2hbZPOYLocSzE5ghznae7WZhEtfnXCBlcbU",

  // Legacy format for backward compatibility
  LAUNDROMAT: {
    URL: "https://mbppphoddpitkedffmao.supabase.co",
    ANON_KEY: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1icHBwaG9kZHBpdGtlZGZmbWFvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzA5MDk1MTQsImV4cCI6MjA0NjQ4NTUxNH0.8e1ugDoUBryeoMGKgV0AVRuYnNq1AKSplXUL-qCys5Q",
    SERVICE_KEY: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1icHBwaG9kZHBpdGtlZGZmbWFvIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTczMDkwOTUxNCwiZXhwIjoyMDQ2NDg1NTE0fQ._UezhGRf2hbZPOYLocSzE5ghznae7WZhEtfnXCBlcbU"
  }
};

// Client options
const clientOptions = {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
  global: {
    headers: {
      'Accept': 'application/json'
    }
  }
};

// Single client instance for all business types - this prevents multiple GoTrueClient instances
let supabaseClient = null;
let serviceRoleClient = null;
let isCreatingClient = false;
let isCreatingServiceClient = false;

const createSupabaseClient = () => {
  // Prevent multiple simultaneous client creation
  if (isCreatingClient) {
    // Wait for the client to be created
    return new Promise((resolve) => {
      const checkClient = () => {
        if (supabaseClient) {
          resolve(supabaseClient);
        } else {
          setTimeout(checkClient, 10);
        }
      };
      checkClient();
    });
  }

  if (!supabaseClient) {
    isCreatingClient = true;


    supabaseClient = createClient(
      SUPABASE_CONFIG.URL,
      SUPABASE_CONFIG.ANON_KEY,
      {
        ...clientOptions,
        auth: {
          ...clientOptions.auth,
          storageKey: 'savants-auth' // Single storage key for all business types
        }
      }
    );

    isCreatingClient = false;

  }

  return supabaseClient;
};

const createServiceRoleClient = () => {
  // Prevent multiple simultaneous service client creation
  if (isCreatingServiceClient) {
    return new Promise((resolve) => {
      const checkClient = () => {
        if (serviceRoleClient) {
          resolve(serviceRoleClient);
        } else {
          setTimeout(checkClient, 10);
        }
      };
      checkClient();
    });
  }

  if (!serviceRoleClient) {
    isCreatingServiceClient = true;

    serviceRoleClient = createClient(
      SUPABASE_CONFIG.URL,
      SUPABASE_CONFIG.SERVICE_KEY,
      {
        auth: {
          autoRefreshToken: false,
          persistSession: false,
          detectSessionInUrl: false,
        },
        global: {
          headers: {
            'Accept': 'application/json'
          }
        }
      }
    );

    isCreatingServiceClient = false;
  }

  return serviceRoleClient;
};

// Simple function that always returns the same client instance
export const getSupabaseClient = (businessType) => {
  return createSupabaseClient();
};

// New function to get service role client
export const getServiceRoleClient = () => {
  return createServiceRoleClient();
};

// For backwards compatibility - create the client once
export const supabase = createSupabaseClient();

// Export business types for compatibility
export const BUSINESS_TYPES = {
  CLEANING: 'cleaning',
  LAUNDROMAT: 'laundromat',
  SHORT_TERM_RENTALS: 'short_term_rentals',
  SELF_STORAGE: 'self_storage',
  PROPERTY_MANAGERS: 'property_management'
};